import React, { useState } from "react";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../App.css";
import AddPersonModal from "../helpers/AddPersonModal";

const TOKEN = "unwantedtok";
const AUTH_HEADER = {
  Authorization: `Bearer ${TOKEN}`,
};

function MainNavbar() {
  const [showModal, setShowModal] = useState(false);
  const API_BASE = "https://prdp-api.suport-949.workers.dev/api/inscrieri-membri";

  const handleAddPerson = async (person) => {
    const newPerson = { ...person, timestamp: new Date().toISOString() };
    try {
      const response = await fetch(API_BASE, {
        method: "POST",
        headers: { "Content-Type": "application/json", ...AUTH_HEADER },
        body: JSON.stringify(newPerson),
      });
      if (response.ok) setShowModal(false);
    } catch (error) {
      console.error("Eroare de rețea:", error);
    }
  };

  return (
    <>
      <Navbar
        fixed="top"
        expand="lg"
        variant="dark"
        className="custom-dark-navbar shadow-sm"
      >
        {/* Am scos 'fluid' pentru a nu se mai lipi de marginile ecranului */}
        <Container>
          
          {/* Logo și Text (Stânga) */}
          <Navbar.Brand href="/" className="d-flex align-items-center">
            <img src="/logo192.jpg" alt="PRDP" width="40" className="me-2 rounded" />
            <span className="navbar-brand-text">PRDP</span>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="navContent" />
          
          <Navbar.Collapse id="navContent">
            {/* Navigarea și butoanele în dreapta */}
            <Nav className="ms-auto align-items-center">
              <Nav.Link href="https://prdp.ro" className="nav-link-custom text-center">Acasă</Nav.Link>
              <Nav.Link href="/" className="nav-link-custom active text-center">Proiecte</Nav.Link>
              <Nav.Link href="https://prdp.ro/donatii" target="_blank" rel="noopener noreferrer" className="nav-link-custom text-center">Donează</Nav.Link>
              <Nav.Link href="/contact" className="nav-link-custom text-center">Contact</Nav.Link>

              {/* Butonul Devino membru */}
              <div className="d-flex ms-lg-4 mt-3 mt-lg-0">
                <Button
                  className="btn-devino-membru-yellow rounded-pill fw-bold px-4 py-2"
                  onClick={() => setShowModal(true)}
                >
                  Devino membru
                </Button>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <div className="navbar-spacer"></div>

      <AddPersonModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onSave={handleAddPerson}
        title="Înscriere ca membru / voluntar"
      />
    </>
  );
}

export default MainNavbar;